import { render, staticRenderFns } from "./askExamManage.vue?vue&type=template&id=49b28c17&scoped=true&"
import script from "./askExamManage.vue?vue&type=script&lang=js&"
export * from "./askExamManage.vue?vue&type=script&lang=js&"
import style0 from "./askExamManage.vue?vue&type=style&index=0&id=49b28c17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b28c17",
  null
  
)

export default component.exports